module.exports = __webpack_public_path__ + "media/images/elionline/icons/icona_classe-23881f042100054db838d1f80296e793.svg";